<template>
  <div class="hc-table" data-testid="hc-table-root">
    <div class="hc-table__scroll">
      <table class="hc-table__table" :class="`hc-table--align-${align}`">
        <thead v-if="headers.length" class="hc-table__head">
          <tr>
            <th v-for="(header, index) in headers" :key="index" scope="col">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, rowIndex) in visibleRows"
            :key="rowIndex"
            class="hc-table__row"
          >
            <td v-for="(cell, cellIndex) in row" :key="cellIndex">
              {{ cell }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="paginationEnabled && totalPages > 1"
      class="hc-table__pagination"
      data-testid="hc-table-pagination"
    >
      <table-footer-pagination
        :current-page="currentPage"
        :total-count="rows.length"
        :total-pages="totalPages"
        @page-change="goToPage"
      />
    </div>
  </div>
</template>

<script>
import tableMixin from './mixins/tableMixin';
import TableFooterPagination from 'dashboard/components/widgets/TableFooterPagination.vue';

export default {
  name: 'TableBlock',
  components: { TableFooterPagination },
  mixins: [tableMixin],
};
</script>

<style src="./styles/TableBlock.scss" lang="scss" scoped></style>
